// extracted by mini-css-extract-plugin
module.exports = {"p":"UiInputElLabel_p__3kTHq"};